import CouponMarketplaceHeader from './coupon-marketplace-header-view'

export default CouponMarketplaceHeader
